import { graphql } from "./generated/gql";

export const SponsorsQuery = graphql(`
  query Sponsors($limit: Int!, $offset: Int!) {
    sponsors(limit: $limit, offset: $offset) {
      nodes {
        sponsorId
        name
        description
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`);

export const SponsorQuery = graphql(`
  query Sponsor($sponsorId: ID!) {
    sponsor(sponsorId: $sponsorId) {
      sponsorId
      name
      description
      createdAt
      updatedAt
    }
  }
`);
